/**
 * @file
 *
 * @fileoverview A slot to allow disabling social buttons based on values of the form (applicant form).
 */

/**
 * Allows disabling social buttons based on values of the form.
 *
 * @returns {Object} The disable social buttons data.
 */
export function useDisableSocialButtons(gdpr: any = {}, consentInfo: any = {}) {
  return { disableSocialButtons: false };
}

/**
 * Allows passing custom field information to the OAuth sign up process.
 *
 * @returns {Object} The custom fields data.
 */
export function passCustomFieldsDataToOAuthSignUp(
  values: any = {},
  consents: any = {},
) {
  return {};
}
